import { GiftIconV2 } from './GiftIconV2';

export default GiftIconV2;
